// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"71c51388","304":"1a860439","352":"7203089a","488":"e9f92e33","988":"1807d93f"}[chunkId] + ".chunk.js";
};